var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("house types")])
}
var staticRenderFns = []

export { render, staticRenderFns }